import React from 'react';
import { Button } from 'primereact/button';
import ImageComponent from 'shared/ImageComponent';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import '../mailbox.scss';
import { Tag } from 'primereact/tag';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { UserDetailsContext } from 'context/userDetailsContext';
import { useContext } from 'react';

const MailList = ({
  allMails,
  selectedEmailThreadPk,
  setSelectedEmailThreadPkSk,
  handleLoadMore,
  loading,
  hasNext,
  paginationLoading,
  readEmails,
  setReadEmails,
  multiple = false,
  selectedEmails = [],
  setSelectedEmails = () => {},
}) => {
  const userContext = useContext(UserDetailsContext);

  const toggleEmailSelection = (pk, sk, email_thread_id) => {
    setSelectedEmails((prev) => {
      const exists = prev.some((email) => email.pk === pk && email.sk === sk);
      return exists ? prev.filter((email) => email.pk !== pk || email.sk !== sk) : [...prev, { pk, sk, email_thread_id }];
    });
  };
  const handleEmailClick = (mail) => {
    setSelectedEmailThreadPkSk({ pk: mail?.pk, sk: mail?.sk });
    setReadEmails((prev) => ({ ...prev, [mail?.pk]: true }));
  };
  if (!allMails?.length) {
    return (
      <div className="text-message-height mailbox">
        <div className="msg-holder pt-0" style={{ overflow: 'hidden auto' }}>
          <div className="d-flex align-items-center justify-content-center">
            <h6 className="text-center" style={{ marginTop: '80px' }}>
              No emails found
            </h6>
          </div>
        </div>
      </div>
    );
  }

  const statusMapping = {
    SUCCESS: 'Mapped By AI',
    BYPASSED: 'Mapping Bypassed',
    FAILED: 'AI Mapping Failed',
    MANUAL_OVERRIDE: 'Mapped By User',
    NO_MATCH_FOUND: 'Unmapped By AI',
    IN_PROGRESS: 'Mapping In Progress',
    QUEUED: 'Mapping Scheduled',
    LAWFT_ORIGIN: 'Originated in Lawft',
    FAILED_MAIL: 'Failed Mail Deliveries',
  };

  const getStatusClass = (status) => {
    if (status === 'SUCCESS') return 's-tag'; // Success
    if (status === 'FAILED' || status === 'FAILED_MAIL') return 'da-tag'; // Failure
    if (status === 'IN_PROGRESS') return 'b-tag'; // In Progress
    return 'y-tag'; // All others
  };

  return (
    <>
      <GlobalLoader />
      <div className="text-message-height mailbox">
        {/* Mail List Container */}
        <div className="msg-holder pt-0" style={{ height: 'auto', overflow: 'hidden auto' }}>
          <div className="border-top">
            {allMails?.map((mail) => {
              const isUnread = mail?.is_unread && !readEmails[mail?.pk];
              const isChecked = selectedEmails.some((email) => email.pk === mail.pk && email.sk === mail.sk);

              return (
                <div
                  className="mail-list-outer-box flex-row-reverse inner-border-bottom"
                  key={mail?.sk + mail?.time}
                  style={{
                    backgroundColor: selectedEmailThreadPk === mail?.pk ? 'var(--selected-msg)' : 'var(--white)',
                  }}
                >
                  <button
                    className="w-100 p-2 ps-0 pointer mail-list-box"
                    style={{
                      backgroundColor: selectedEmailThreadPk === mail?.pk ? 'var(--selected-msg)' : 'var(--white)',
                      border: 'none',
                      padding: '12px',
                      cursor: 'pointer',
                      textAlign: 'left',
                      display: 'block',
                    }}
                    tabIndex="0"
                    onClick={() => {
                      handleEmailClick(mail);
                    }}
                  >
                    <div className={`d-flex align-items-center`}>
                      <div className="px-2 position-relative">
                        <ImageComponent
                          fileName={mail?.email_from?.user_email?.charAt(0)}
                          style={{ backgroundColor: '#2196F3', color: '#ffffff' }}
                          fileSize="medium.jpg"
                        />
                        {isUnread && <i className="icon-window-filled mail-list-badge"></i>}
                      </div>
                      <div className={`col-10 ${isUnread ? 'unread-email' : ''}`}>
                        <div
                          style={{
                            marginBottom: '0.3rem',
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="text-break black-700 mb-0 pe-2">
                              {mail?.email_from?.user_name || mail?.email_from?.user_email}
                            </h6>
                            <div>
                              {mail?.ai_reconciliation_status || mail?.failed_delivery || mail?.lawft_origin ? (
                                <Tag
                                  className={`tag-case mail-ai-tags text-center d-status-tags d-flex ${getStatusClass(
                                    mail?.failed_delivery ? 'FAILED_MAIL' : mail.ai_reconciliation_status
                                  )}`}
                                  rounded
                                  value={
                                    <>
                                      <i className="bi bi-stars me-2"></i>
                                      {statusMapping[
                                        mail?.failed_delivery
                                          ? 'FAILED_MAIL'
                                          : mail?.lawft_origin
                                          ? 'LAWFT_ORIGIN'
                                          : mail?.ai_reconciliation_status
                                      ] || mail?.ai_reconciliation_status}
                                    </>
                                  }
                                />
                              ) : null}
                            </div>
                          </div>
                          <span className={`pointer text-break text-primary-dark ${mail?.is_unread && 'text-bold'}`}>{mail?.subject}</span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-hint black-600">
                            {handleDateTimeOffset(userContext?.userDetails?.timezone, mail?.time, 'MM-DD-YYYY')}
                          </span>
                          <span className="text-hint black-600">
                            {handleDateTimeOffset(userContext?.userDetails?.timezone, mail?.time, 'hh:mm A')}
                          </span>
                        </div>
                      </div>
                    </div>
                  </button>
                  {multiple && (
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => toggleEmailSelection(mail.pk, mail.sk, mail.email_thread_id)}
                      className="ms-2"
                    />
                  )}
                </div>
              );
            })}
          </div>
          {loading && (
            <div className="text-center p-3">
              <i className="pi pi-spin pi-spinner" /> Loading more emails...
            </div>
          )}
          {hasNext && (
            <div className="text-center">
              <Button type="button" className="load-more-btn w-100" onClick={handleLoadMore} disabled={!hasNext}>
                Load More
              </Button>
            </div>
          )}
          {paginationLoading && (
            <div className="text-center p-3">
              <i className="pi pi-spin pi-spinner" /> Loading more emails...
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MailList;
